import React from 'react';
import { TypedUseSelectorHook, createDispatchHook, createSelectorHook } from 'react-redux';
import type { DashboardDispatch, DashboardState } from './dashboardStore';

// We need to create a second context to have the dashboard as a second independent store.
export const dashboardContext = React.createContext(null) as any;
export const useDashboardDispatch = createDispatchHook<DashboardDispatch>(dashboardContext);
export const useDashboardSelector: TypedUseSelectorHook<DashboardState> = createSelectorHook(dashboardContext);
